module.exports = __webpack_public_path__ + "img/padlock-white.7df80459.png";